export default function roundToNDigits(number, digits = 2) {
  return parseFloat(parseFloat(number).toFixed(digits))
}
